import { LegalPage } from "../components/LegalPage";
import { useSeo } from "../lib/useSeo";

export default function Terms() {
  useSeo({
    title: "Terms | SimplyRefer",
    description: "Terms of use for SimplyRefer users, GP practices, clinicians and clinics in Australia.",
    canonicalPath: "/terms",
  });
  return (
    <LegalPage title="Terms of Service" updated="June 2026" testId="terms-page">
      <p>
        These Terms of Service ("Terms") govern your access to and use of SimplyRefer (the "Service"), a referral
        platform connecting general practitioners ("GPs"), clinicians, and clinic managers. By creating an account or
        using the Service, you agree to these Terms.
      </p>

      <h2>1. Eligibility & accounts</h2>
      <p>
        You must be a registered healthcare professional, practice, or authorised staff member to use the Service.
        Clinicians listed in the directory must hold current registration with the Australian Health Practitioner
        Regulation Agency (AHPRA). You are responsible for the accuracy of the information you provide and for keeping
        your account credentials secure.
      </p>

      <h2>2. AHPRA verification</h2>
      <p>
        Clinician profiles are only made visible to GPs after SimplyRefer reviews the supplied AHPRA registration
        number. SimplyRefer may suspend or remove any profile that cannot be verified or whose registration lapses.
        Verification is a good-faith check and does not constitute an endorsement of any practitioner.
      </p>

      <h2>3. Free trial & subscriptions</h2>
      <p>
        New clinics and individual practitioners receive a 3-month free trial. GPs use the Service at no charge. After the trial,
        continued listing requires an active subscription (Individual, Clinic Light, or Clinic Plus). Fees, billing cycles,
        and plan limits are shown at checkout and may change with notice.
      </p>

      <h2>4. Referrals and SimplyRefer References</h2>
      <p>
        SimplyRefer helps a GP choose a clinician and record the referral option used. A GP may also create an optional
        SimplyRefer Reference for the referral. We store the referring practice, clinician, referral option and reference
        without recording patient health information. We do not provide medical advice and are not a party to the clinical relationship between a GP, clinician,
        and patient. You remain solely responsible for clinical decisions, record-keeping, and compliance with applicable laws.
      </p>

      <h2>5. Acceptable use</h2>
      <ul>
        <li>Do not misuse the Service, attempt to bypass security, or access data you are not authorised to view.</li>
        <li>Do not upload unlawful, misleading, or harmful content.</li>
        <li>Handle all patient and personal information in accordance with the Privacy Act 1988 (Cth) and applicable health records legislation.</li>
      </ul>

      <h2>6. Availability & changes</h2>
      <p>
        We strive to keep the Service available but do not guarantee uninterrupted access. We may modify, suspend, or
        discontinue features at any time. We may update these Terms; continued use after changes constitutes acceptance.
      </p>

      <h2>7. Liability</h2>
      <p>
        To the extent permitted by law, SimplyRefer is provided "as is" without warranties, and our liability is limited
        to the fees you paid in the preceding three months. Nothing in these Terms excludes rights that cannot lawfully
        be excluded under Australian Consumer Law.
      </p>
    </LegalPage>
  );
}
